/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "fdddf89b0172caa91a3d60db81a36f515c809da3";
